import styled from "@emotion/styled";

export const InputHidden = styled.input`
  visibility: hidden;
  position: absolute;
  left: -999px;
`